import { mapBoard } from './daily-checkin.mappers';
import type { ApiFetchDailyCheckinPort } from '~/handlers/ports/api-fetch-daily-checkin.port';
import type { DailyCheckinBoard } from '~/types/daily-checkin';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

// GET /daily-check-in/board — trilha do período corrente + estado do jogador
// numa resposta só (o épico exige isso pra o front não encadear requests).
//
// Identidade é o TOKEN, e só ele (ENG-801). O `user_id` que ia na query saiu:
// o core resolve o dono pelo Bearer, como já fazem `/players/me`,
// `/promocodes/redeem` e `/crm-level/sync`.
//
// Isso encerra a dívida registrada aqui — com o id na query, um token válido
// conseguia ler o board de OUTRO jogador. Não havia o que validar no cliente:
// quem manda o parâmetro escolhe o valor.
//
// E resolve um bug de UX pela raiz: o `user_id` era a única razão de a store
// exigir o perfil carregado antes de chamar. Quem abria o check-in na janela
// entre "token pronto" e "perfil carregado" via "Tente novamente" sem que
// requisição nenhuma tivesse saído.
//
// Limite do core: 120 req/min. O cache do handler (5 min) é o que garante que
// abrir e fechar o modal não encoste nesse teto.
export class ApostatudoApiFetchDailyCheckinAdapter
  implements ApiFetchDailyCheckinPort
{
  async handle(): Promise<DailyCheckinBoard> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(
      `${getApostatudoApiUrl()}/daily-check-in/board`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`DailyCheckin board failed: ${response.status}`);
    }

    // Resposta plana, sem envelope `data` — o board é o corpo inteiro.
    return mapBoard(await response.json());
  }
}
